import React from 'react';
import { Dialog, Drawer, Popover, useMediaQuery } from '../../ui/core';
import { floatSurfaceSx, useTheme } from '../../ui/styles';

// One overlay, two sizes of screen: a bottom sheet on a phone, and on desktop
// either a dropdown under `anchorEl` (`dropdown`) or a centred dialog. Children
// are the usual DialogTitle / DialogContent / DialogActions — each container is
// a flex column, so the title and actions stay put while the content scrolls.
const ResponsiveSheet = ({ open, onClose, dropdown = false, anchorEl = null, maxWidth = 'xs', children }) => {
  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down('md'));

  if (compact) {
    return (
      <Drawer
        anchor="bottom"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            maxHeight: '85vh',
            pb: 'env(safe-area-inset-bottom)',
          },
        }}
      >
        {children}
      </Drawer>
    );
  }

  if (dropdown) {
    return (
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: { mt: '8px', ...floatSurfaceSx, maxHeight: '70vh', display: 'flex', flexDirection: 'column' },
        }}
      >
        {children}
      </Popover>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      {children}
    </Dialog>
  );
};

export default ResponsiveSheet;
